import React, { useState } from 'react';
import { withRouter } from 'react-router-dom';
import { useGetRecord } from 'root/admin/components/hooks';
import { Title } from 'root/admin/components';

import { FileInput, Form, Field, Loader, RelationSelect, DatePicker } from '@smartplatform/ui';
import { Thumbnail } from '../../components/form/Thumbnail';

const MainSlideEdit = ({ match, rootPath, type, tabName, path }) => {
	const [articleDate, setArticleDate] = useState();
	const { id } = match.params;
	const options = {};
	const record = useGetRecord({ model: 'MainSlide', id, options });

	const onSave = async record => {
		if (!record.order) {
			record.order = record.id;
			record.save();
		}
	};

	if (!record) {
		return <Loader />;
	}
	
	const setDataRange = (date) => {
		const articleDate = new Date(date);
		articleDate.setHours(articleDate.getHours() + 3);
		const nextDayArticleDate = new Date(
			articleDate.getFullYear(),
			articleDate.getMonth(),
			articleDate.getDate() + 1,
			articleDate.getHours(),
		);
		return [articleDate.toISOString(), nextDayArticleDate.toISOString()];
	}

	console.log('record', record);

	return (
		<div>
			<Title record={record} name="Бегущая строка" />
			<Form record={record} rootPath={rootPath} onSave={onSave}>
				<Field
					property="name"
					label="Отображаемый заголовок (оставьте пустым если хотите использовать заголовок материала)"
				/>
				<Field label="Отфильтровать материалы по дате">
					<DatePicker onChange={(date) => setArticleDate(date)}/>
				</Field>
				<Field
					label="Материал (отсавьте пустым для использования ссылку на другой материал)"
					relation="article"
					property="name"
				>
					<RelationSelect filter={articleDate ?
						{ where: { publishAt: { between: setDataRange(articleDate) } } } : {}}
					/>
				</Field>
				<Field property="link" label="Ссылка" />
				<Thumbnail record={record} />
			</Form>
		</div>
	);
};

export default withRouter(MainSlideEdit);
